export default __webpack_public_path__ + "img/blue_legal_icon.8c4d73c6579d6504bb9ea33c647507d5.svg";